function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    style: {
      "position": "absolute"
    },
    viewBox: "0 0 22.476 22.476"
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "prefix__settings",
    d: "M21.947 8.679L20.219 8.3a9.4 9.4 0 0 0-.556-1.341l.956-1.488a.672.672 0 0 0-.09-.838l-2.69-2.687a.672.672 0 0 0-.839-.09l-1.488.956a9.4 9.4 0 0 0-1.341-.556L13.8.529A.672.672 0 0 0 13.141 0H9.335a.672.672 0 0 0-.656.529L8.3 2.256a9.4 9.4 0 0 0-1.341.556l-1.484-.956a.672.672 0 0 0-.838.09L1.946 4.637a.672.672 0 0 0-.09.838l.956 1.488A9.4 9.4 0 0 0 2.256 8.3l-1.727.379A.672.672 0 0 0 0 9.335v3.806a.672.672 0 0 0 .529.656l1.727.376a9.4 9.4 0 0 0 .556 1.341L1.856 17a.672.672 0 0 0 .09.838l2.691 2.692a.672.672 0 0 0 .838.09l1.488-.956a9.4 9.4 0 0 0 1.341.556l.376 1.727a.672.672 0 0 0 .656.529h3.806a.672.672 0 0 0 .656-.529l.376-1.727a9.4 9.4 0 0 0 1.341-.556L17 20.62a.672.672 0 0 0 .838-.09l2.691-2.691A.672.672 0 0 0 20.62 17l-.956-1.488a9.4 9.4 0 0 0 .556-1.341l1.727-.376a.672.672 0 0 0 .529-.656V9.335a.672.672 0 0 0-.529-.656zm-6.68 2.559a4.03 4.03 0 1 1-4.03-4.03 4.034 4.034 0 0 1 4.03 4.03zm0 0",
    style: {
      "fill": "#1ac9e8"
    }
  }));
};

export default __webpack_public_path__ + "static/media/settings.7fb333f5.svg";
export { SvgComponent as ReactComponent };